module.exports = __webpack_public_path__ + "img/sunrise.ffaaccf2.gif";